<script setup>
import ApiKeyForm from "@/components/api-key/ApiKeyForm.vue"

const route = useRoute()
const router = useRouter()

const loading = ref()

const load = () => {
  loading.value = true
  setTimeout(() => {
    loading.value = false
  }, 3000)
}

definePage({
  meta: {
    layout: "default",
  },
})

const pageTitle = "Data API Key"

const pageMethod = "Update"

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "API Key",
    to: null,
  },
  {
    title: pageMethod,
    to: null,
  },
]
</script>

<template>
  <VBreadcrumbs
    :items="breadCrumbs"
    class="px-0 pt-0 pb-5"
  />
  <ApiKeyForm
    v-model:pageMethod="pageMethod"
    v-model:pageTitle="pageTitle"
  />
</template>
